/*
 * C Quiz: step-by-step "Find your pomade" quiz (snippets/c-quiz.liquid).
 *
 * Scoring matches c-find-product: style and hair type score by
 * position in the product's ranked list, hold and finish score on a match,
 * "Unsure" never scores, ties go to pool order.
 */
(function () {
  if (customElements.get('c-quiz')) return;

  var LOADER_MS = 700;

  function norm(v) {
    return (v || '')
      .toString()
      .toLowerCase()
      .replace(/\s*\/\s*/g, ' / ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // An answer matches a metafield token if they are equal or one contains the
  // other (handles phrasing like "strong hold" vs "strong").
  function tokenMatch(answer, value) {
    var a = norm(answer);
    var b = norm(value);
    if (!a || !b || a === 'unsure') return false;
    return a === b || b.indexOf(a) > -1 || a.indexOf(b) > -1;
  }

  function parseList(str) {
    try {
      return (JSON.parse(str) || []).map(norm);
    } catch (e) {
      return [];
    }
  }

  // Ranked list: earlier = higher.
  function listScore(answer, list) {
    for (var i = 0; i < list.length; i++) {
      if (tokenMatch(answer, list[i])) {
        return { hit: true, factor: (list.length - i) / list.length, index: i };
      }
    }
    return { hit: false, factor: 0, index: -1 };
  }

  function anyMatch(answer, list) {
    for (var i = 0; i < list.length; i++) {
      if (tokenMatch(answer, list[i])) return true;
    }
    return false;
  }

  function capitalise(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // Replaces [name] placeholders in a Theme settings string.
  function fill(template, vars) {
    return (template || '').replace(/\[(\w+)\]/g, function (match, key) {
      return key in vars ? vars[key] : match;
    });
  }

  class CQuiz extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.card = this.querySelector('.c-quiz__card');
      this.questions = Array.prototype.slice.call(this.querySelectorAll('.c-quiz__q'));
      this.steps = Array.prototype.slice.call(this.querySelectorAll('.c-quiz__step'));
      this.fill = this.querySelector('.c-quiz__fill');
      this.progressDesk = this.querySelector('.c-quiz__progress-desk');
      this.progressMob = this.querySelector('.c-quiz__progress-mob');
      this.footer = this.querySelector('.c-quiz__footer');
      this.backBtn = this.querySelector('.c-quiz__back');
      this.nextBtn = this.querySelector('.c-quiz__next');
      this.nextLabel = this.querySelector('.c-quiz__next-label');
      this.loader = this.querySelector('.c-quiz__loader');
      this.results = this.querySelector('.c-quiz__results');
      this.grid = this.querySelector('.c-quiz__grid');
      this.items = Array.prototype.slice.call(this.querySelectorAll('.c-quiz__pool-item'));
      this.items.forEach(function (item) {
        item.__card = item.querySelector('.custom-card');
      });

      this.weights = {
        style: parseFloat(this.dataset.weightStyle) || 0,
        hold: parseFloat(this.dataset.weightHold) || 0,
        finish: parseFloat(this.dataset.weightFinish) || 0,
        type: parseFloat(this.dataset.weightType) || 0
      };
      this.current = 0;

      this.addEventListener('change', this.onChange.bind(this));
      this.backBtn.addEventListener('click', this.back.bind(this));
      this.nextBtn.addEventListener('click', this.next.bind(this));
      this.querySelector('.c-quiz__restart').addEventListener('click', this.restart.bind(this));
      Array.prototype.forEach.call(this.querySelectorAll('.c-quiz__arrow'), function (arrow) {
        arrow.addEventListener('click', function () {
          var track = arrow.parentElement.querySelector('.c-quiz__opts');
          var first = track.querySelector('.c-quiz__opt');
          var step = first ? first.getBoundingClientRect().width + 12 : 164;
          track.scrollBy({ left: step * 2 * parseInt(arrow.dataset.scroll, 10), behavior: 'smooth' });
        });
      });

      this.show(0);
    }

    answer(q) {
      var checked = q.querySelector('.c-quiz__radio:checked');
      return checked ? checked.value : null;
    }

    answers() {
      var out = {};
      var self = this;
      this.questions.forEach(function (q) {
        out[q.dataset.role] = self.answer(q);
      });
      return out;
    }

    onChange(e) {
      if (!e.target.classList.contains('c-quiz__radio')) return;
      this.refresh();
    }

    show(index) {
      var self = this;
      this.current = index;
      this.questions.forEach(function (q, i) {
        q.hidden = i !== index;
      });
      this.refresh();
    }

    refresh() {
      var self = this;
      var total = this.questions.length;
      var index = this.current;
      var q = this.questions[index];
      var picked = !!this.answer(q);

      this.steps.forEach(function (step, i) {
        var status = step.querySelector('.c-quiz__step-status');
        var ans = self.answer(self.questions[i]);
        var done = i < index || (self.card.dataset.state === 'results');
        step.classList.toggle('is-current', i === index && !done);
        step.classList.toggle('is-done', done);
        if (done) {
          status.textContent = ans || '';
        } else if (i === index) {
          status.textContent = status.dataset.current;
        } else {
          status.textContent = status.dataset.next;
        }
      });

      var complete = this.card.dataset.state === 'results';
      var n = complete ? total : index + 1;
      this.fill.style.width = (n / total) * 100 + '%';
      this.progressDesk.textContent = complete ? this.dataset.completeLabel : n + ' / ' + total;
      this.progressMob.textContent = complete
        ? this.dataset.completeLabel
        : fill(this.dataset.stepLabel, { n: n, total: total, step: q.dataset.stepName });

      this.backBtn.disabled = index === 0;
      this.nextBtn.disabled = !picked;
      this.nextLabel.textContent = index === total - 1 ? this.nextBtn.dataset.submitLabel : this.nextBtn.dataset.nextLabel;
    }

    back() {
      if (this.current > 0) this.show(this.current - 1);
    }

    next() {
      if (!this.answer(this.questions[this.current])) return;
      if (this.current < this.questions.length - 1) {
        this.show(this.current + 1);
        var first = this.questions[this.current].querySelector('.c-quiz__radio');
        if (first) first.focus({ preventScroll: true });
        return;
      }
      this.submit();
    }

    submit() {
      var self = this;
      if (!this.items.length) return;
      this.card.dataset.state = 'loading';
      this.questions.forEach(function (q) {
        q.hidden = true;
      });
      this.footer.hidden = true;
      this.loader.hidden = false;
      setTimeout(function () {
        self.run();
      }, LOADER_MS);
    }

    score(item, ans) {
      var d = { total: 0 };
      d.style = listScore(ans.style, parseList(item.dataset.styles));
      d.total += d.style.factor * this.weights.style;
      d.type = listScore(ans.type, parseList(item.dataset.types));
      d.total += d.type.factor * this.weights.type;
      d.hold = anyMatch(ans.hold, parseList(item.dataset.hold));
      if (d.hold) d.total += this.weights.hold;
      d.finish = anyMatch(ans.finish, parseList(item.dataset.finish));
      if (d.finish) d.total += this.weights.finish;
      return d;
    }

    // The "why we picked it" copy, built from the scoring breakdown with the
    // size dropped from the title and the style answer capitalised.
    why(item, ans, d, isBest) {
      var t = this.dataset;
      var vars = {
        product: item.dataset.title,
        style: capitalise(norm(ans.style)),
        hold: norm(ans.hold),
        finish: norm(ans.finish),
        type: norm(ans.type),
      };
      var reasons = [];
      if (d.style.hit) reasons.push(fill(d.style.index === 0 ? t.whyStyleTop : t.whyStyle, vars));
      if (d.hold) reasons.push(fill(t.whyHold, vars));
      if (d.finish) reasons.push(fill(t.whyFinish, vars));
      if (d.type.hit) reasons.push(fill(t.whyType, vars));

      var copy;
      if (reasons.length) {
        vars.reasons =
          reasons.length > 1
            ? reasons.slice(0, -1).join(', ') + ' ' + t.whyAnd + ' ' + reasons[reasons.length - 1]
            : reasons[0];
        copy = fill(isBest ? t.whyBest : t.whyOther, vars);
      } else {
        copy = fill(t.whyFallback, vars);
      }
      return capitalise(copy);
    }

    homeCards() {
      this.items.forEach(function (item) {
        if (item.__card && item.__card.parentNode !== item) item.appendChild(item.__card);
      });
    }

    run() {
      var self = this;
      var ans = this.answers();
      var ranked = this.items
        .map(function (item) {
          return { item: item, d: self.score(item, ans) };
        })
        .sort(function (a, b) {
          if (b.d.total !== a.d.total) return b.d.total - a.d.total;
          return (parseInt(a.item.dataset.order, 10) || 0) - (parseInt(b.item.dataset.order, 10) || 0);
        })
        .slice(0, 3);

      this.homeCards();
      this.grid.innerHTML = '';
      ranked.forEach(function (entry, i) {
        var isBest = i === 0;
        var wrap = document.createElement('div');
        wrap.className = 'c-quiz__result';
        var card = entry.item.__card;
        if (card) {
          var media = card.querySelector('.c-pc-media') || card;
          var prior = media.querySelector('.c-quiz__badge');
          if (prior) prior.remove();
          var badge = document.createElement('span');
          badge.className = 'c-quiz__badge' + (isBest ? '' : ' c-quiz__badge--great');
          badge.textContent = isBest ? self.dataset.bestLabel : self.dataset.greatLabel;
          media.insertBefore(badge, media.firstChild);
          wrap.appendChild(card);
        }
        var why = document.createElement('div');
        why.className = 'c-quiz__why';
        var h = document.createElement('p');
        h.className = 'c-quiz__why-title';
        h.textContent = self.dataset.whyHeading;
        var p = document.createElement('p');
        p.className = 'c-quiz__why-body';
        p.textContent = self.why(entry.item, ans, entry.d, isBest);
        why.appendChild(h);
        why.appendChild(p);
        wrap.appendChild(why);
        self.grid.appendChild(wrap);
      });

      this.loader.hidden = true;
      this.card.dataset.state = 'results';
      this.results.hidden = false;
      this.refresh();
      this.results.focus({ preventScroll: true });
      this.keepInView();
    }

    // Bring the card's top edge into view below the sticky header, but only
    // when it is hidden.
    keepInView() {
      var header = document.querySelector('#header-component');
      var offset = 16;
      if (header) {
        // A visible (sticky or not yet scrolled away) header covers the top of the viewport.
        var bottom = header.getBoundingClientRect().bottom;
        if (bottom > 0) offset += bottom;
      }
      var top = this.card.getBoundingClientRect().top;
      if (top < offset || top > window.innerHeight * 0.6) {
        window.scrollBy({ top: top - offset, behavior: 'smooth' });
      }
    }

    restart() {
      this.homeCards();
      this.grid.innerHTML = '';
      this.results.hidden = true;
      this.loader.hidden = true;
      this.footer.hidden = false;
      Array.prototype.forEach.call(this.querySelectorAll('.c-quiz__radio'), function (r) {
        r.checked = false;
      });
      Array.prototype.forEach.call(this.querySelectorAll('.c-quiz__opts'), function (t) {
        t.scrollLeft = 0;
      });
      this.card.dataset.state = 'questions';
      this.show(0);
      this.keepInView();
      var first = this.questions[0].querySelector('.c-quiz__radio');
      if (first) first.focus({ preventScroll: true });
    }
  }

  customElements.define('c-quiz', CQuiz);
})();
